import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider, useAuth } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
// import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import ImageList from './pages/ImageList';
import TagManagement from './pages/TagManagement';
import ImageTagging from './pages/ImageTagging';
import DeviceTypeManagement from './pages/DeviceTypeManagement';
import SortCategoryManagement from './pages/SortCategoryManagement';
import ChangePassword from './pages/ChangePassword';
import AppManagement from './pages/AppManagement';
import FirmwareVersionManagement from './pages/FirmwareVersionManagement';
import AppVersionManagement from './pages/AppVersionManagement';
import MaterialManagement from './pages/MaterialManagement';
import FlashWriterAuthCodeManagement from './pages/FlashWriterAuthCodeManagement';
import { setUnauthorizedHandler } from './services/api';
import './App.css';

// 401错误处理组件，用于设置全局的未授权处理逻辑
const UnauthorizedHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // 设置401错误处理函数
    setUnauthorizedHandler(() => {
      logout(); // 清理认证状态
      navigate('/login', { replace: true }); // 导航到登录页
    });
  }, [logout, navigate]);

  return <>{children}</>;
};

// App内部组件，用于访问AuthContext
const AppContent: React.FC = () => {
  return (
    <Router>
      <UnauthorizedHandler>
        <Routes>
          {/* 公开路由 */}
          <Route path="/login" element={<Login />} />
          {/* <Route path="/register" element={<Register />} /> */}

          {/* 需要认证的路由 */}
          <Route path="/" element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="upload" element={<Upload />} />
            <Route path="image-list" element={<ImageList />} />
            <Route path="tag-management" element={<TagManagement />} />
            <Route path="image-tagging" element={<ImageTagging />} />
            <Route path="device-type-management" element={<DeviceTypeManagement />} />
            <Route path="sort-category-management" element={<SortCategoryManagement />} />
            <Route path="app-management" element={<AppManagement />} />
            <Route path="firmware-version-management" element={<FirmwareVersionManagement />} />
            <Route path="app-version-management" element={<AppVersionManagement />} />
            <Route path="material-management" element={<MaterialManagement />} />
            <Route path="flash-writer-auth-code-management" element={<FlashWriterAuthCodeManagement />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>

          {/* 默认重定向 */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </UnauthorizedHandler>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
